import moment from "moment-jalaali";
import React from "react";
import "./Select.scss";

const Select = (props) => {
  const { list, value, setValue, Color, last } = props;

  return (
    <ul
      className="selectList"
      style={{ borderColor: value && Color ? `rgb(${Color})` : "black" }}
    >
      {list.map((item) => (
        <li
          key={item.gainValue}
          className={value === item.gainValue ? "active" : ""}
          onClick={() => setValue(item.gainValue)}
          style={{
            backgroundColor:
              value === item.gainValue && Color ? `rgba(${Color}, 0.4)` : "",
          }}
        >
          <img src={item.img} alt={item.value} />
          <div>
            <div>{item.value}</div>
            <div>
              {last && last[item.gainValue]?.toFixed(2)} ({item.unit})
            </div>
            <div>
              {last && last.date && moment(last.date).format("jYYYY/jMM/jDD")}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default Select;
